import { useState } from "react";

const C = {
  bg0: "#020913",
  blue: "#00a2ff",
  blueDark: "#0062cc",
  text: "#e2edf7",
  muted: "#7a9ab5",
  border: "rgba(0,162,255,0.14)",
  cardBg: "rgba(6,21,41,0.85)",
  red: "#e53935",
};

// ✅ اسم المستخدم وكلمة السر - غيريهم لاحقاً
const USERS = [
  { username: "admin", password: "samware2025" },
];

export default function DashboardLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = () => {
    const user = USERS.find(
      u => u.username === username && u.password === password
    );
    if (user) {
      localStorage.setItem("dashboard_auth", "true");
      onLogin();
    } else {
      setError("Invalid username or password!");
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    background: "rgba(0,162,255,0.05)",
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    color: C.text,
    fontSize: 15,
    outline: "none",
    marginTop: 6,
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: C.bg0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        background: C.cardBg,
        border: `1px solid ${C.border}`,
        borderRadius: 16,
        padding: "40px 36px",
        width: "100%",
        maxWidth: 400,
      }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56,
            background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
            borderRadius: 14,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 24, fontWeight: 800, color: "#fff",
            marginBottom: 12,
          }}>S</div>
          <h1 style={{ color: C.text, fontSize: 22, fontWeight: 800, margin: 0 }}>Dashboard Login</h1>
          <p style={{ color: C.muted, fontSize: 14, marginTop: 6 }}>SAMware-cs Admin Panel</p>
        </div>

        {/* Form */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label style={{ color: C.muted, fontSize: 13 }}>Username</label>
            <input
              style={inputStyle}
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
            />
          </div>
          <div>
            <label style={{ color: C.muted, fontSize: 13 }}>Password</label>
            <input
              style={inputStyle}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              onKeyDown={e => e.key === "Enter" && handleLogin()}
            />
          </div>

          {error && (
            <p style={{ color: C.red, fontSize: 13, margin: 0 }}>⚠️ {error}</p>
          )}

          <button onClick={handleLogin} style={{
            background: `linear-gradient(135deg, ${C.blueDark}, ${C.blue})`,
            color: "#fff", border: "none", borderRadius: 8,
            padding: "13px", fontSize: 15, fontWeight: 600,
            cursor: "pointer", marginTop: 8,
          }}>
            Login
          </button>
        </div>
      </div>
    </div>
  );
}